import type { I18nOptions } from 'vue-i18n'

// All datetime formats use Europe/Berlin timezone (CET/CEST) to ensure consistent display
// regardless of the user's browser timezone. Backend stores all datetimes as UTC.
const TIMEZONE = 'Europe/Berlin'

const dateTimeFormats: I18nOptions['datetimeFormats'] = {
  en: {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      timeZone: TIMEZONE,
      hour12: false,
    },
    dateonly: {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: TIMEZONE,
      hour12: false,
    },
    dateonlywd: {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: TIMEZONE,
      hour12: false,
    },

    datetime: {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: TIMEZONE,
      hour12: false,
    },
    datetimezone: {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: TIMEZONE,
      timeZoneName: 'short',
      hour12: false,
    },
    datetimewd: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: TIMEZONE,
      hour12: false,
    },
    datetimefull: {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: TIMEZONE,
      hour12: false,
    },
    timeonly: {
      hour: 'numeric',
      minute: 'numeric',
      timeZone: TIMEZONE,
      hour12: false,
    },
    timeonlyzone: {
      hour: 'numeric',
      minute: 'numeric',
      timeZone: TIMEZONE,
      timeZoneName: 'short',
      hour12: false,
    },
    timeonlyfull: {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: TIMEZONE,
      hour12: false,
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: TIMEZONE,
      hour12: false,
    },
  },
  de: {
    short: {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: TIMEZONE,
    },
    dateonly: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: TIMEZONE,
    },
    dateonlywd: {
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: TIMEZONE,
    },
    datetime: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
    },
    datetimezone: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
      timeZoneName: 'short',
    },
    datetimewd: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
    },
    datetimefull: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: TIMEZONE,
    },
    timeonly: {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
    },
    timeonlyzone: {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
      timeZoneName: 'short',
    },
    timeonlyfull: {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: TIMEZONE,
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: TIMEZONE,
    },
  },
  es: {
    short: {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: TIMEZONE,
    },
    dateonly: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: TIMEZONE,
    },
    dateonlywd: {
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: TIMEZONE,
    },
    datetime: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
    },
    datetimezone: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
      timeZoneName: 'short',
    },
    datetimewd: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
    },
    datetimefull: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: TIMEZONE,
    },
    timeonly: {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
    },
    timeonlyzone: {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
      timeZoneName: 'short',
    },
    timeonlyfull: {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: TIMEZONE,
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: TIMEZONE,
    },
  },
}

export default dateTimeFormats
